module.exports = __webpack_public_path__ + "img/keder_gelb_candy.0d8e5066.jpg";